import React, { memo } from 'react';
import { PlayerHeader } from '../header';
import { Content404 } from '@zmedia/bm-soccer-ui/modules/shared/components/404';
import { Columns } from '@zmedia/bm-soccer-ui/components';

interface IProps {
    className?: string;
    children: React.ReactNode;
    error?: number;
}

export function PagePlayerWrap(props: IProps) {
    const { error, children } = props;

    if (typeof error !== 'undefined' && error < 0) {
        return <Content404 error={error} />;
    }

    return (
        <>
            <Columns>
                <Columns.Column type="main">
                    <PlayerHeader {...props} />
                    {children}
                </Columns.Column>
            </Columns>
        </>
    );
}

export default memo(PagePlayerWrap);
